import { ApiHttpService, ApiHttpServiceNewApi } from '../ApiHttpService';
import { ProductSerializer } from '../serializers/ProductSerializer';
import { SimpleProductSerializer } from '../serializers/SimpleProductSerializer';
import { Product } from '../../models/Product';
import { SimpleProduct } from '../../models/SimpleProduct';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const PRODUCT_PATH = 'articulos/';
const RELATED_PRODUCTS_PATH = 'articulos/articulosrelacionados/';
const PRODUCT_ACCESSORIES_PATH = 'articulos/accesorios/';
const PRODUCTS_BY_CATEGORY_PATH = 'articulos/Agrupados/';
const PRODUCT_SEARCH_PATH = 'articulos/ObtenerProductosBusqueda/';

const NEWAPI_PRODUCT_BY_GROUP = '/ArticleES/articles-by-group';
const NEWAPI_PLANS = '/ArticleES/articles-with-plan';

function capitalizeKeys(obj) {
  if (obj !== null && typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return obj.map(item => capitalizeKeys(item));
    }
    const newObj = {};
    Object.keys(obj).forEach((key) => {
      // Convertimos la primera letra de la clave a mayúscula
      const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        newObj[capitalizedKey] = capitalizeKeys(obj[key]);
      } else {
        newObj[capitalizedKey] = obj[key];
      }
    });
    return newObj;
  }

  // Si no es un objeto, lo devolvemos tal cual
  return obj;
}

class ProductsController {
  static async find(id) {
    const response = await ApiHttpService.get(`${PRODUCT_PATH}${id}`);
    const deSerializedData = ProductSerializer.deSerialize(response.data);
    return new Product(deSerializedData);
  }

  static async findByCategory(subMenuId, productTypeId, queryFilter) {
    const params = {
      idSubFamilia: subMenuId || 0,
      idGrupo: productTypeId || 0,
      filtroBusquedaIntra: queryFilter,
    };
    const response = await ApiHttpService.get(`${PRODUCTS_BY_CATEGORY_PATH}${ParamsHelper.createQueryParams(params)}`);
    const deSerializedData = response.data.map(SimpleProductSerializer.deSerialize);
    return deSerializedData.map(prod => new SimpleProduct(prod));
  }

  static async findRelated(id) {
    const response = await ApiHttpService.get(`${RELATED_PRODUCTS_PATH}${id}`);
    const deSerializedData = response.data.map(SimpleProductSerializer.deSerialize);
    return deSerializedData.map(prod => new SimpleProduct(prod));
  }

  static async findAccessories(id) {
    const response = await ApiHttpService.get(`${PRODUCT_ACCESSORIES_PATH}${id}`);
    const deSerializedData = response.data.map(SimpleProductSerializer.deSerialize);
    return deSerializedData.map(prod => new SimpleProduct(prod));
  }

  static async search(query, queryFilter) {
    const params = ParamsHelper.createQueryParams({
      busqueda: query,
      filtroBusquedaIntra: queryFilter,
    });
    const response = await ApiHttpService.get(`${PRODUCT_SEARCH_PATH}${params}`);
    const deSerializedData = response.data.map(SimpleProductSerializer.deSerialize);
    return deSerializedData.map(prod => new SimpleProduct(prod));
  }

  static async findByGroupNewApi(slug) {
    const params = {
      slug,
    };
    const response = await ApiHttpServiceNewApi.get(`${NEWAPI_PRODUCT_BY_GROUP}${ParamsHelper.createQueryParams(params)}`);
    const { articles, ...group } = response.data.data;
    const deSerializedData = articles
      .map(x => JSON.parse(x))
      .map(x => capitalizeKeys(x))
      .map(SimpleProductSerializer.deSerialize);
    return {
      group,
      products: deSerializedData.map(prod => new SimpleProduct(prod)),
    };
  }

  static async findPlansNewApi() {
    const response = await ApiHttpServiceNewApi.get(NEWAPI_PLANS);
    return response.data.data;
  }
}

export { ProductsController };



// WEBPACK FOOTER //
// ./src/networking/controllers/ProductsController.js